import React, { Component } from 'react'
// import { Col, Row, Spinner, Modal, ModalBody, Button, TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap'
import {
  Row,
  Col,
  Button,
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Input,
  Spinner,
} from 'reactstrap'
import { withFirebase } from '../Fb'
// import ReactTable from 'react-table'
import moment from 'moment'
import AddCircleIcon from '@mui/icons-material/AddCircle'
// import VpnKeyIcon from '@mui/icons-material/VpnKey'
// import MailOutlineIcon from '@mui/icons-material/MailOutline'
// import AlternateEmailIcon from '@mui/icons-material/AlternateEmail'
// import PhoneIcon from '@mui/icons-material/Phone'
// import AnnouncementIcon from '@mui/icons-material/Announcement'
// import EditIcon from '@mui/icons-material/Edit'
// import IconButton from '@mui/material/IconButton'
// import MuiButton from '@mui/material/Button'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'

import TextField from '@mui/material/TextField'
import FormControl from '@mui/material/FormControl'
import InputAdornment from '@mui/material/InputAdornment'
import MenuItem from '@mui/material/MenuItem'
import InputLabel from '@mui/material/InputLabel'
import Select from '@mui/material/Select'
import FormControlLabel from '@mui/material/FormControlLabel'
import Checkbox from '@mui/material/Checkbox'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
import { ListItem, Typography, ListItemText, ListItemSecondaryAction, Divider } from '@mui/material'
// import TabPanel from '@mui/lab/TabPanel'
import WarningIcon from '@mui/icons-material/Warning'
import ExpandLess from '@mui/icons-material/ExpandLess'
import ExpandMore from '@mui/icons-material/ExpandMore'
import Collapse from '@mui/material/Collapse'
import { CopyToClipboard } from 'react-copy-to-clipboard'
// import ReactTable from '../Lists/ReactTableWrapper'
import { DataGrid } from '@mui/x-data-grid'
import EditButton from '../Buttons/EditButton'
// import PersonBenefitCards from './PersonBenefitCards'
import PersonSearch from '../Inputs/PersonSearch'
import BillingOperatorSelect from './BillingOperatorSelect'
import Infobox from '../Infos/Infobox'
import { DEFAULT_SPORTS, DEFAULT_TYPES } from '../../sports'
import { benefitsSummary, chargeStatus, formatChargeStatus, isContinuous } from '../utils/memberships'

const ACL_FIELDS = ['allowpostpayment', 'blocked', 'blockedMessage', 'quotaoverride']

const paymenttypes = [
  {
    value: 'transfer',
    label: 'Siirto',
  },
  {
    value: 'compensation',
    label: 'Hyvitys',
  },
  {
    value: 'deposit',
    label: 'Talletus',
  },
]

function TabPanel(props) {
  const { children, value, index, ...other } = props

  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && <React.Fragment>{children}</React.Fragment>}
    </div>
  )
}

/** reservations formatting starts */

const getUnixTime = (reservation, border) => {
  const timeOfDayHelper = moment.utc(reservation.resourcegroups[0][border])
  const ordering = moment.utc(reservation.occurency.date)
  ordering.hour(timeOfDayHelper.hour()).minute(timeOfDayHelper.minute())
  if (moment().utcOffset() > 0) {
    ordering.subtract(moment().utcOffset(), 'minute')
  } else {
    ordering.add(moment().utcOffset(), 'minute')
  }
  return ordering.unix()
}

const isInvoiced = (reservation) => {
  const { occurency, payments } = reservation
  if (!payments) return false
  if (occurency) {
    return payments.filter((x) => x.occurency === occurency.date).filter((x) => x.type === 'invoice').length > 0
  } else {
    return payments.filter((x) => x.type === 'invoice').length > 0
  }
}

const missingPayment = (reservation, costAsCents) => {
  const { payments, occurency } = reservation

  if (!payments)
    return { missing: costAsCents > 0, amount: parseFloat((costAsCents / 100).toFixed(2)), haspayments: false }
  if (occurency) {
    // console.log('occurency', occurency)
    // console.log('payments', payments)
    const paidAsCents = payments
      .filter((x) => x.type !== 'refund')
      .filter((x) => {
        if (x.occurency) {
          return x.occurency === occurency.date
        } else {
          return true
        }
      })
      .reduce((a, x) => a + x.amount, 0)
    // console.log('paidAsCents', paidAsCents, 'costAsCents', costAsCents)
    const amount = parseFloat(((costAsCents - paidAsCents) / 100).toFixed(2))
    // console.log('amount', amount)
    return { missing: paidAsCents < costAsCents, amount, haspayments: true }
  } else {
    // console.log('payments', payments)
    const paidAsCents = payments.filter((x) => x.type !== 'refund').reduce((a, x) => a + x.amount, 0)
    // console.log('paidAsCents', paidAsCents, 'costAsCents', costAsCents)
    const amount = parseFloat(((costAsCents - paidAsCents) / 100).toFixed(2))
    // console.log('amount', amount)
    return { missing: paidAsCents < costAsCents, amount, haspayments: true }
  }
}

const refundedPayment = (reservation) => {
  const { payments, occurency } = reservation
  if (!payments) return { refunded: false, amount: 0 }
  let timestamp = ''
  if (occurency) {
    const _amount = payments
      .filter((x) => x.type === 'refund')
      .filter((x) => x.occurency === occurency.date)
      .reduce((a, x) => {
        timestamp = x.timestamp
        return a + x.amount
      }, 0)
    const amount = Math.abs(parseFloat((_amount / 100).toFixed(2)))
    return { refunded: amount > 0, amount, timestamp }
  } else {
    const _amount = payments
      .filter((x) => x.type === 'refund')
      .reduce((a, x) => {
        timestamp = x.timestamp
        return a + x.amount
      }, 0)
    const amount = Math.abs(parseFloat((_amount / 100).toFixed(2)))
    return { refunded: amount > 0, amount, timestamp }
  }
}

const isRecurring = (reservation) => {
  return reservation.isrecurring || reservation.parentid
}

const isCancelled = (reservation) => {
  if (reservation?.occurency?.state) {
    return reservation?.occurency?.state === 'cancelled'
  }
  return reservation.state === 'cancelled'
}

const isOnSale = (reservation) => {
  if (reservation?.occurency?.state) {
    return reservation?.occurency?.state === 'onsale'
  }
  return reservation.state === 'onsale'
}

const isPast = (reservation) => {
  const debugTime = new URLSearchParams(window.location.search).get('time')
  if (debugTime) return reservation.ordering < moment(debugTime).unix()
  return reservation.ordering < moment().unix()
}

const isUpcoming = (reservation) => {
  // const debugTime = new URLSearchParams(window.location.search).get('time')
  // if (debugTime) {
  //   if (reservation.occurency.date.startsWith('2022-10-04')) {
  //     // console.log(
  //     //   'isUpcoming',
  //     //   reservation.ordering,
  //     //   moment(debugTime).unix(),
  //     //   reservation.ordering > moment(debugTime).unix()
  //     // )
  //   }
  //   return reservation.ordering > moment(debugTime).unix()
  // }
  return reservation.ordering > moment().unix()
}

const isStarted = (reservation) => {
  const rUnix = getUnixTime(reservation, 'start')
  return rUnix > moment().unix()
}

const isStored = (reservation) => {
  return reservation.isstored || reservation?.occurency?.isstored
}

const isMoved = (reservation) => {
  if (reservation.parentid) {
    return true
  }
  return false
}

const getCost = (reservation) => {
  const { resourcegroups } = reservation
  if (!resourcegroups) console.log(reservation)
  let cost = 0
  if (resourcegroups[0]) {
    if (resourcegroups[0].hasOwnProperty('cost')) {
      cost = parseFloat(resourcegroups[0].cost)
    }
    if (resourcegroups[0].hasOwnProperty('overridecost')) {
      if (typeof resourcegroups[0].overridecost === 'string') {
        if (!isNaN(parseFloat(resourcegroups[0].overridecost))) {
          cost = parseFloat(resourcegroups[0].overridecost)
        }
      } else {
        cost = parseFloat(resourcegroups[0].overridecost)
      }
    }
  }
  return cost
}

/** reservations formatting ends **/

// function EditIconButton(props) {
//   return (
//     <IconButton aria-label='Muokkaa' onClick={props.onClick} size='small'>
//       <EditIcon fontSize='small' />
//     </IconButton>
//   )
// }

class OrganisationDetails extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: true,
      reservationModalOpen: false,
      loadingModalOpen: false,
      reservations: [],
      formattedReservations: [],
      saldoloading: true,
      storageloading: true,
      membershipsloading: true,
      membershippermanent: false,
      aclsloading: true,
      acls: {},
      showAddMembershipRow: false,
      venues: [],
      activeTab: '1',
      removeOrganisationConfirmation: false,
      saldodescription: null,
      saldotype: null,
      saldowallet: null,
      saldovenue: null,
      saldoamount: 0,
      savingsaldo: false,
      storagedescription: null,
      storagetype: null,
      storagewallet: null,
      storagevenue: null,
      storageamount: 0,
      savingstorage: false,
      tabValue: 0,
      messages: [],
      messagesloading: true,
      messageopen: [],
      messaging: { isOpen: false },
      copied: false,
      passwordResetLink: '',
      cardsloading: true,
      cards: [],
      organisationDataEdit: false,
      organisationDataSaved: true,
      organisation: this.props.organisation,
    }
  }

  componentDidMount() {
    // console.log('mount')
    // this.getReservations(this.state.organisation.id)
    // this.getSaldo(this.state.organisation.id)
    this.updateData()
  }

  componentDidUpdate(prevProps) {
    if (this.props.organisation && prevProps.organisation) {
      if (prevProps.organisation.id !== this.props.organisation.id) {
        this.setState({ saldos: [], organisation: this.props.organisation }, () => {
          this.updateData()
        })
      }
    }
  }

  updateData = () => {
    this.setState({
      loading: true,
      saldoloading: true,
      storageloading: true,
      membershipsloading: true,
      cardsloading: false,
      aclsloading: false,
      pinloading: true,
      messagesloading: false,
      membershipend: moment.utc().endOf('year').format('YYYY-MM-DD'),
      membershipstart: moment.utc().format('YYYY-MM-DD'),
      contactid: null,
      pin: null
    })

    const contactid = this.state.organisation?.contacts?.[0]?.id || null

    this.props.firebase
      .getVenues()
      .then((v) => {
        // get pin
        let venues = []
        if (!v.empty) {
          v.docs.forEach((doc) => {
            if (doc.data().state !== 'deleted') {
              venues.push(doc.data().name.toLowerCase())
            }
          })
        }
        this.setState({ venues, contactid })
        return this.props.firebase.getPersonPin(contactid)
      })
      .then((pindata) => {
        // get memberships
        let pin = null
        if (!pindata?.data?.error) {
          pin = pindata.data
        }
        this.setState({ pin, pinloading: false })
        return Promise.all([
          this.props.firebase.getOrganisationMemberships(this.state.organisation.id),
          this.props.firebase.getMemberships(),
        ])
      })
      .then(([m, allm]) => {
        // get acls
        const membershipOptions = []
        if (!allm.empty) {
          // eslint-disable-next-line
          allm.docs.map((doc) => {
            if (doc.data().state !== 'deleted') {
              membershipOptions.push({ ...doc.data(), id: doc.id })
            }
          })
        }
        this.setState({
          memberships: m.data,
          membershipsloading: false,
          membershipoptions: membershipOptions,
        })
        return Promise.all([
          this.props.firebase.getOrganisationSaldo(this.state.organisation.id),
          this.props.firebase.getOrganisationStorage(this.state.organisation.id),
        ])
      })
      .then(([s, st]) => {
        // get messages
        this.setState({ saldos: s.data, storages: st.data, saldoloading: false, storageloading: false, loading: false })
      })

    // return Promise.all([this.props.firebase.getAcls(this.state.organisation.id)])
    // .then(([acls]) => {
    //   // get saldos
    //   let aclsdata = {}
    //   if (acls.data.acl) {
    //     aclsdata = acls.data.acl
    //   }
    //   this.setState({ acls: aclsdata, aclsloading: false })
    //   return Promise.all([
    //     this.props.firebase.getPersonSaldo(this.state.organisation.id),
    //     this.props.firebase.getPersonStorage(this.state.organisation.id),
    //   ])
    // })
    // .then(([s, st]) => {
    //   // get messages
    //   this.setState({ saldos: s.data, storages: st.data, saldoloading: false, storageloading: false, loading: false })
    //   return this.props.firebase.getPersonMessages(this.state.organisation.id)
    // })
    // .then((messages) => {
    //   messages.sort((a, b) => {
    //     if (a.timestamp.seconds > b.timestamp.seconds) {
    //       return -1
    //     }
    //     if (a.timestamp.seconds < b.timestamp.seconds) {
    //       return 1
    //     }
    //     return 0
    //   })
    //   const messageopen = []
    //   for (let i = 0; i < messages.length; i++) {
    //     messageopen.push(false)
    //   }
    //   this.setState({ messages, messagesloading: false, messageopen })
    //   return Promise.all([
    //     this.props.firebase.getPersonBenefitCards(this.state.organisation.id),
    //     this.props.firebase.getBenefitCards(),
    //   ])
    // })
    // .then(([personcards, benefitcards]) => {
    //   let _d = benefitcards.docs.map((sh) => {
    //     return { ...sh.data(), id: sh.id }
    //   })
    //   console.log('personcards', personcards)
    //   this.setState({ cards: personcards.data, benefitcards: _d, cardsloading: false })
    // })

    this.props.firebase
      .getOrganisationReservations(this.state.organisation.id)
      .then((r) => {
        const raw = []
        if (!r.empty) {
          r.forEach((doc) => {
            raw.push({ ...doc.data(), id: doc.id })
          })
        }
        const reservations = this.formatToTable(raw)
        const _reservations = this.formatReservations(raw)
        this.setState({
          reservations,
          raw,
          formattedReservations: _reservations,
        })
      })
  }

  setAcl = (data) => {
    this.setState({ aclsloading: true })
    const update = { userid: this.state.organisation.id, acl: data }
    this.props.firebase.setAcl(update).then((response) => {
      // console.log('response', response)
      this.setState({ aclsloading: false, acls: response.data.acl })
    })
  }

  getStatus = (reservation) => {
    const _cost = getCost(reservation)
    const _missingPayment = missingPayment(reservation, _cost * 100)
    // console.log('_missingPayment', _missingPayment, 'cost', _cost)
    const _refundedPayment = refundedPayment(reservation, _cost * 100)
    const _payedPayment = { payed: _cost - _missingPayment.amount > _cost, amount: _cost - _missingPayment.amount }
    const _isPast = isPast(reservation)
    const _isPaid = _missingPayment.missing === false
    const _isCancelled = isCancelled(reservation)
    const _isOnSale = isOnSale(reservation)
    const _isRecurring = isRecurring(reservation)
    const _isStored = isStored(reservation)
    const _isUpcoming = isUpcoming(reservation)
    const _isInvoiced = isInvoiced(reservation)
    const _isStarted = isStarted(reservation)
    const _isCancellable = _isStarted && !_isCancelled && !_isOnSale && !_isRecurring && !_isStored && !_isInvoiced
    const _isSellable = _isStarted && !_isCancelled && !_isOnSale && !_isStored
    const _isPayable = !_isPaid && !_isInvoiced && !(_isCancelled && !_isStored)
    const _isStorable = _isStarted && !_isCancelled && _isRecurring && !_isStored
    const _showAccessCode = _isUpcoming && !_isCancelled && !_isOnSale
    const _isSplittable = !_isCancelled && !_isOnSale && _isRecurring && !_isPaid
    const _isRefunded = _refundedPayment.refunded === true
    const _isReceiptEnabled = !_isInvoiced && _isPaid && !_isRefunded && _cost > 0
    const _isMoved = isMoved(reservation)

    return {
      cost: _cost,
      isCancellable: _isCancellable,
      isCancelled: _isCancelled,
      isInvoiced: _isInvoiced,
      isMoved: _isMoved,
      isOnSale: _isOnSale,
      isPaid: _isPaid,
      isPast: _isPast,
      isPayable: _isPayable,
      isReceiptEnabled: _isReceiptEnabled,
      isRecurring: _isRecurring,
      isRefunded: _isRefunded,
      isSellable: _isSellable,
      isSplittable: _isSplittable,
      isStarted: _isStarted,
      isStorable: _isStorable,
      isStored: _isStored,
      isUpcoming: _isUpcoming,
      missingPayment: _missingPayment,
      payedPayment: _payedPayment,
      refundedPayment: _refundedPayment,
      showAccessCode: _showAccessCode,
    }
  }

  formatReservations = (reservations) => {
    // let _m = Object.keys(firestore.data['ownReservations'])
    //   .map((key) => {
    //     return {
    //       ...firestore.data['ownReservations'][key],
    //       id: key,
    //       selectkey: key,
    //     }
    //   })
    //   .filter((r) => hasResource(r) && r.locationid === appconfig.accountkey && r.state !== 'user_cancelled')
    // .filter((r) => {
    //   if (r.isrecurring) {
    //     return r.state !== 'cancelled' // all cancelled !if past not shoud be invisible
    //   } else {
    //     return true
    //   }
    // })
    let _m = reservations
      .filter((r) => r.state !== 'user_cancelled')
      .map((r) => {
        if (r.isrecurring) {
          return r.recurrencyDates
            .map((rec) => {
              let _r = JSON.parse(JSON.stringify(r))
              let _sKey = _r.selectkey + '-'
              if (typeof rec === 'object') {
                _r.occurency = { date: rec.date, state: rec.state, isstored: rec.isstored }
                _r.state = rec.state
                _sKey += rec.date
                if (rec.state === 'moved') return null
              } else {
                _r.occurency = { date: rec }
                _sKey += rec
              }
              _r.selectkey = _sKey // _r.selectkey + '-' + rec
              const timeOfDayHelper = moment.utc(_r.resourcegroups[0].start)
              const ordering = moment.utc(_r.occurency.date)
              ordering.hour(timeOfDayHelper.hour()).minute(timeOfDayHelper.minute())
              if (moment().utcOffset() > 0) {
                ordering.subtract(moment().utcOffset(), 'minute')
              } else {
                ordering.add(moment().utcOffset(), 'minute')
              }
              _r.ordering = ordering.unix()
              _r.starttime = ordering
              // _r.occurency = { date: moment.utc(r.resourcegroups[0].start).format('YYYY-MM-DD') }
              _r.start = moment.utc(r.resourcegroups?.[0]?.start).format('HH:mm')
              _r.end = moment.utc(r.resourcegroups?.[0]?.end).format('HH:mm')
              _r.court = r.resourcegroups?.[0]?.resources?.[0]?.displayName
              _r.resourcetype = r.resourcegroups?.[0]?.resources?.[0]?.category
              _r.reservationtype = r.isrecurring ? 'Vakio' : r.parentid ? 'Siirretty vakio' : 'Irto'
              return _r
            })
            .filter((x) => x)
        } else {
          const ordering = moment.utc(r.resourcegroups[0].end)
          if (moment().utcOffset() > 0) {
            ordering.subtract(moment().utcOffset(), 'minute')
          } else {
            ordering.add(moment().utcOffset(), 'minute')
          }
          r.ordering = ordering.unix()
          r.starttime = ordering
          r.occurency = { date: moment.utc(r.resourcegroups[0].start).format('YYYY-MM-DD') }
          r.start = moment.utc(r.resourcegroups?.[0]?.start).format('HH:mm')
          r.end = moment.utc(r.resourcegroups?.[0]?.end).format('HH:mm')
          r.resourcetype = r.resourcegroups?.[0]?.resources?.[0]?.category
          r.reservationtype = r.isrecurring ? 'Vakio' : r.parentid ? 'Siirretty vakio' : 'Irto'
          r.court = r.resourcegroups?.[0]?.resources?.[0]?.displayName
          return r
        }
      })
      .flat(3)
      .map((r) => {
        r.vs = this.getStatus(r)
        r.id = r.occurency.date + '---' + r.id
        r.cost = r.vs.cost
        r.paid = r.vs.isPaid ? 'Kyllä' : 'Ei'
        r.invoiced = r.vs.isInvoiced ? 'Kyllä' : 'Ei'
        r.stateName =
          r.state === 'cancelled'
            ? 'Peruttu'
            : r.state === 'onsale'
            ? 'Myynnissä'
            : r.state === 'stored'
            ? 'Varastoitu'
            : 'Varattu'
        return r
      })

    _m.sort(function (a, b) {
      if (a.ordering < b.ordering) {
        return -1
      } else if (a.ordering > b.ordering) {
        return 1
      } else {
        return 0
      }
    })

    return _m
  }

  /** resevations format ends */

  formatToTable = (reservations) => {
    return reservations.map((r) => {
      const ret = {
        id: r.id,
        recurrencyDates: r.recurrencyDates || [],
        cost: r.cost,
        payments: r.payments || [],
        reservationtype: r.isrecurring ? 'Vakio' : 'Irto',
        state: r.state,
      }
      ret.day = moment.utc(r.resourcegroups?.[0]?.start).format('dd DD.MM.YY')
      ret.start = moment.utc(r.resourcegroups?.[0]?.start).format('HH:mm')
      ret.end = moment.utc(r.resourcegroups?.[0]?.end).format('HH:mm')
      ret.court = r.resourcegroups?.[0]?.resources?.[0]?.displayName
      ret.resourcetype = r.resourcegroups?.[0]?.resources?.[0]?.category
      ret.starttime = r.resourcegroups?.[0]?.start
      return ret
    })
  }

  // getReservations = async (id) => {
  //   // console.log('get reservations', id)
  //   const raw = []
  //   const reservationsSnapshot = await this.props.firebase.getPersonReservations(this.state.organisation.id).get()
  //   if (!reservationsSnapshot.empty) {
  //     reservationsSnapshot.forEach((doc) => {
  //       // console.log(doc.id, '=>', doc.data())
  //       raw.push({ ...doc.data(), id: doc.id })
  //     })
  //   }
  //   const reservations = this.formatToTable(raw)
  //   this.setState({ loading: false, reservations, raw })
  // }

  getSaldo = async (id) => {
    this.setState({ saldoloading: true })
    const saldos = await this.props.firebase.getPersonSaldo(this.state.organisation.id)
    this.setState({ saldos: saldos.data, saldoloading: false })
  }

  getStorage = async (id) => {
    this.setState({ storageloading: true })
    const storages = await this.props.firebase.getPersonStorage(this.state.organisation.id)
    this.setState({ storages: storages.data, storageloading: false })
  }

  getMemberships = async (id) => {
    this.setState({ membershipsloading: true })
    const m = await this.props.firebase.getOrganisationMemberships(this.state.organisation.id)
    this.setState({ memberships: m.data, membershipsloading: false })
  }

  getBenefitCards = async () => {
    this.setState({ cardsloading: true })
    const b = await this.props.firebase.getPersonBenefitCards(this.state.organisation.id)
    this.setState({ cards: b.data, cardsloading: false })
  }

  toggleReservationModal = () => {
    this.setState({ reservationModalOpen: !this.state.reservationModalOpen })
  }

  toggleLoadingModal = () => {
    this.setState({ loadingModalOpen: !this.state.loadingModalOpen })
  }

  handleMembershipSelection = (e) => {
    const membershipselection = e.target.value
    this.setState({ membershipselection })
  }

  handleMembershipStart = (e) => {
    const membershipstart = e.target.value
    this.setState({ membershipstart })
  }

  handleMembershipEnd = (e) => {
    const membershipend = e.target.value
    this.setState({ membershipend })
  }

  handleMembershipPermanent = (e) => {
    const membershippermanent = e.target.checked
    this.setState({ membershippermanent })
  }

  handleMembershipNote = (e) => {
    const membershipnote = e.target.value
    this.setState({ membershipnote })
  }

  handleSaldoAmount = (e) => {
    const saldoamount = e.target.value
    this.setState({ saldoamount })
  }

  handleSaldoVenue = (e) => {
    const saldovenue = e.target.value
    this.setState({ saldovenue })
  }

  handleSaldoType = (e) => {
    const saldotype = e.target.value
    this.setState({ saldotype })
  }

  handleSaldoWallet = (e) => {
    const saldowallet = e.target.value
    this.setState({ saldowallet })
  }

  handleSaldoDescription = (e) => {
    const saldodescription = e.target.value
    this.setState({ saldodescription })
  }

  handleStorageAmount = (e) => {
    const storageamount = e.target.value
    this.setState({ storageamount })
  }

  handleStorageVenue = (e) => {
    const storagevenue = e.target.value
    this.setState({ storagevenue })
  }

  handleStorageType = (e) => {
    const storagetype = e.target.value
    this.setState({ storagetype })
  }

  handleStorageWallet = (e) => {
    const storagewallet = e.target.value
    this.setState({ storagewallet })
  }

  handleStorageDescription = (e) => {
    const storagedescription = e.target.value
    this.setState({ storagedescription })
  }

  handleSelectEvent = async (reservationid, occurency) => {
    const reid = reservationid.split('---').pop()
    if (this.props.onReservationSelect) this.props.onReservationSelect(reid, occurency)
  }

  toggleRemoveDialog = () => {
    this.setState({
      removeOrganisationConfirmation: !this.state.removeOrganisationConfirmation,
    })
  }

  renderOrganisationMemberships = () => {
    const response = []
    if (this.state.membershipsloading) {
      response.push(
        <Row key={'loadingmemberships'} style={{ marginTop: 20 }}>
          <Col>Jäsenyydet</Col>
          <Col>
            <Spinner size='sm' />
          </Col>
        </Row>
      )
    } else if (this.state.memberships && this.state.memberships.length > 0) {
      response.push(<Row key={'loadingmemberships'} style={{ marginTop: 20 }}></Row>)
      for (let k = 0; k < this.state.memberships.length; k++) {
        const membership = this.state.memberships[k]
        const m = this.state.membershipoptions.find((x) => x.id === membership.membershipid)
        if (!m) continue
        const benefits = benefitsSummary(m, DEFAULT_SPORTS, DEFAULT_TYPES)
        const charge = formatChargeStatus(chargeStatus(membership))
        response.push(
          // Keyed on the assignment id rather than Math.random(), which remounted every row
          // on every render.
          <Row key={membership.id || m.id + '-' + k}>
            <Col>
              {m.name}
              {benefits ? <div style={{ fontSize: 12, color: '#6c757d' }}>{benefits}</div> : null}
              {isContinuous(m) ? (
                <div style={{ fontSize: 12, color: '#6c757d' }}>Jatkuva laskutus: {charge || '—'}</div>
              ) : null}
            </Col>
            <Col>
              <Row style={{ marginBottom: 2 }}>
                <Col>{membership.permanent ? 'Pysyvä' : membership.start + ' - ' + membership.end}</Col>
                <Col>
                  {this.props.readOnly ? (
                    membership.permanent || moment.utc(membership.end).isAfter(moment.utc()) ? 'Voimassa' : 'Päättynyt'
                  ) : membership.permanent || moment.utc(membership.end).isAfter(moment.utc()) ? (
                    <>
                      {' '}
                      <Button
                        color='primary'
                        size={'sm'}
                        style={{ margin: 0 }}
                        onClick={() => this.onTerminateMembership(membership.id)}
                      >
                        Päätä jäsenyys
                      </Button>
                    </>
                  ) : (
                    <>
                      {' '}
                      <Button color='danger' size={'sm'} style={{ margin: 0 }}>
                        Päättynyt
                      </Button>
                    </>
                  )}
                </Col>
              </Row>
            </Col>
          </Row>
        )
      }
    } else {
      response.push(
        <Row key={'memberships'} style={{ marginTop: 20 }}>
          <Col>Jäsenyydet</Col>
          <Col>Ei jäsenyyksiä</Col>
        </Row>
      )
    }
    return response
  }

  renderSaldoData = () => {
    const response = []
    if (this.state.saldoloading) {
      response.push(
        <Row key={'loadingsaldo'} style={{ marginTop: 20 }}>
          <Col>Saldo</Col>
          <Col>
            <Spinner size='sm' />
          </Col>
        </Row>
      )
    } else if (this.state.saldos && this.state.saldos.length > 0) {
      response.push(<Row key={'loadingsaldo'} style={{ marginTop: 20 }}></Row>)
      for (let i = 0; i < this.state.saldos.length; i++) {
        const walletTypes = Object.keys(this.state.saldos[i]).filter((x) => x !== 'id')
        for (let k = 0; k < walletTypes.length; k++) {
          const sum = this.state.saldos[i][walletTypes[k]].reduce((acc, curr) => {
            acc = acc + curr.amount
            return acc
          }, 0)
          const walletTitle =
            walletTypes[k] === 'cash' ? 'Kassasaldo' : walletTypes[k] === 'sportmoney' ? 'Liikuntaraha' : walletTypes[k]
          const walletVenue =
            this.state.saldos[i].id !== 'default'
              ? this.state.saldos[i].id.charAt(0).toUpperCase() + this.state.saldos[i].id.slice(1) + ' - '
              : ''

          response.push(
            <Row
              key={walletVenue + '-' + walletTypes[k] + '-' + k}
              onClick={() => this.showSaldoTransaction(walletTypes[k], this.state.saldos[i].id)}
              style={{ cursor: 'pointer' }}
            >
              <Col xs={4} md={2}>
                {this.state.selectedsaldotype &&
                this.state.selectedsaldotype.venue === this.state.saldos[i].id &&
                this.state.selectedsaldotype.category === walletTypes[k] ? (
                  <ExpandLess />
                ) : (
                  <ExpandMore />
                )}{' '}
                {walletVenue} {walletTitle}
              </Col>
              <Col>
                {(sum / 100).toFixed(2).replace('.', ',')} €
                {/* <Row style={{ marginBottom: 2 }}>
                  <Col>{sum / 100} € </Col>
                  <Col>
                    <Button
                      color='link'
                      size={'sm'}
                      style={{ margin: 0 }}
                      onClick={() => this.showSaldoTransaction(walletTypes[k], this.state.saldos[i].id)}
                    >
                      Näytä tapahtumat
                    </Button>
                  </Col>
                </Row> */}
              </Col>
            </Row>
          )
        }
      }
    } else {
      response.push(
        <Row key={'loadingsaldo'} style={{ marginTop: 20 }}>
          <Col>Saldo</Col>
          <Col>Ei saldoa</Col>
        </Row>
      )
    }

    return response
  }

  renderStorageData = () => {
    const response = []
    if (this.state.storageloading) {
      response.push(
        <Row key={'storageloading'} style={{ marginTop: 20 }}>
          <Col>Saldo</Col>
          <Col>
            <Spinner size='sm' />
          </Col>
        </Row>
      )
    } else if (this.state.storages && this.state.storages.length > 0) {
      response.push(<Row key={'storageloading'} style={{ marginTop: 20 }}></Row>)
      for (let i = 0; i < this.state.storages.length; i++) {
        const walletTypes = Object.keys(this.state.storages[i]).filter((x) => x !== 'id')
        for (let k = 0; k < walletTypes.length; k++) {
          const sum = this.state.storages[i][walletTypes[k]].reduce((acc, curr) => {
            acc = acc + curr.amount
            return acc
          }, 0)
          const walletTitle =
            walletTypes[k] === 'cash' ? 'Pankki' : walletTypes[k] === 'minutes' ? 'Varasto' : walletTypes[k]
          const walletVenue =
            this.state.storages[i].id !== 'default'
              ? this.state.storages[i].id.charAt(0).toUpperCase() + this.state.storages[i].id.slice(1) + ' - '
              : ''

          response.push(
            <Row
              key={walletVenue + '-' + walletTypes[k] + '-' + k}
              onClick={() => this.showStorageTransaction(walletTypes[k], this.state.storages[i].id)}
              style={{ cursor: 'pointer' }}
            >
              <Col xs={4} md={2}>
                {this.state.selectedstoragetype &&
                this.state.selectedstoragetype.venue === this.state.storages[i].id &&
                this.state.selectedstoragetype.category === walletTypes[k] ? (
                  <ExpandLess />
                ) : (
                  <ExpandMore />
                )}{' '}
                {walletVenue} {walletTitle}
              </Col>
              <Col>
                {walletTypes[k] === 'minutes' ? sum + ' mins' : (sum / 100).toFixed(2).replace('.', ',') + ' €'}
              </Col>
            </Row>

            // <Row key={walletVenue + '-' + walletTypes[k] + '-' + k}>
            //   <Col>
            //     {walletVenue} {walletTitle}
            //   </Col>
            //   <Col>
            //     <Row style={{ marginBottom: 2 }}>
            //       <Col>{walletTypes[k] === 'minutes' ? sum + ' mins' : sum / 100 + ' €'}</Col>
            //       <Col>
            //         <Button
            //           color='link'
            //           size={'sm'}
            //           style={{ margin: 0 }}
            //           onClick={() => this.showStorageTransaction(walletTypes[k], this.state.storages[i].id)}
            //         >
            //           Näytä tapahtumat
            //         </Button>
            //       </Col>
            //     </Row>
            //   </Col>
            // </Row>
          )
        }
      }
    } else {
      response.push(
        <Row key={'storageloading'} style={{ marginTop: 20 }}>
          <Col>Pankki/Varasto</Col>
          <Col>Ei tapahtumia</Col>
        </Row>
      )
    }

    return response
  }

  showSaldoTransaction = (category, venue) => {
    if (
      this.state.selectedsaldotype &&
      this.state.selectedsaldotype.category === category &&
      this.state.selectedsaldotype.venue === venue
    ) {
      this.setState({ selectedsaldotype: null })
    } else {
      const selectedsaldotype = { venue, category }
      this.setState({ selectedsaldotype })
    }
  }

  showStorageTransaction = (category, venue) => {
    if (
      this.state.selectedstoragetype &&
      this.state.selectedstoragetype.category === category &&
      this.state.selectedstoragetype.venue === venue
    ) {
      this.setState({ selectedstoragetype: null })
    } else {
      const selectedstoragetype = { venue, category }
      // console.log('selectedstoragetype', selectedstoragetype)
      this.setState({ selectedstoragetype })
    }
  }

  renderSaldoTransactions = () => {
    if (!this.state.selectedsaldotype) {
      return <></>
    }
    const _selectedTransactions = this.state.saldos
      .filter((venuesaldos) => venuesaldos.id === this.state.selectedsaldotype.venue)
      .map((s) => s[this.state.selectedsaldotype.category])
      .flat(1)
      .reverse()
    // do some formatting for transactions
    // eslint-disable-next-line array-callback-return
    const selectedTransactions = _selectedTransactions.map((t, i) => {
      if (t.purchasetype === 'reservation' || t.purchasetype === 'activity') {
        if (t.type === 'refund') {
          return (
            <Row
              key={'rtrans-' + i}
              style={{ marginLeft: 10, marginRight: 10, paddingTop: 3, paddingBottom: 3 }}
              className='border-bottom'
            >
              <Col xs={'2'} sm={'2'} md={'2'} lg={'2'}>
                {t.description.startsWith('Peruttu') ? 'Peruutus' : 'Myynti'}
              </Col>
              <Col xs={'5'} sm={'5'} md={'5'} lg={'5'}>
                {t.description}
              </Col>
              <Col xs={'2'} sm={'2'} md={'2'} lg={'2'}>
                {t.amount / 100} €
              </Col>
              <Col xs={'3'} sm={'3'} md={'3'} lg={'3'}>
                {t.timestamp}
              </Col>
            </Row>
          )
        } else if (t.type === 'purchase') {
          return (
            <Row
              key={'rtrans-' + i}
              style={{ marginLeft: 10, marginRight: 10, paddingTop: 3, paddingBottom: 3 }}
              className='border-bottom'
            >
              <Col xs={'2'} sm={'2'} md={'2'} lg={'2'}>
                Varaus
              </Col>
              <Col xs={'5'} sm={'5'} md={'5'} lg={'5'}>
                {t.description}
              </Col>
              <Col xs={'2'} sm={'2'} md={'2'} lg={'2'}>
                {t.amount / 100} €
              </Col>
              <Col xs={'3'} sm={'3'} md={'3'} lg={'3'}>
                {t.timestamp}
              </Col>
            </Row>
          )
        }
      } else {
        let title = ''
        if (t.type === 'compensation') {
          title = 'Hyvitys'
        } else if (t.type === 'transfer') {
          title = 'Siirto'
        } else if (t.type === 'deposit') {
          title = 'Talletus'
        } else {
          return <></>
        }
        return (
          <Row
            key={'rtrans-' + i}
            style={{ marginLeft: 10, marginRight: 10, minHeight: 40, paddingTop: 3, paddingBottom: 3 }}
            className='border-bottom'
          >
            <Col xs={'2'} sm={'2'} md={'2'} lg={'2'}>
              {title}
            </Col>
            <Col xs={'5'} sm={'5'} md={'5'} lg={'5'}>
              {t.description}
            </Col>
            <Col xs={'2'} sm={'2'} md={'2'} lg={'2'}>
              {t.amount / 100} €
            </Col>
            <Col xs={'3'} sm={'3'} md={'3'} lg={'3'}>
              {t.timestamp}
            </Col>
          </Row>
        )
      }
    })
    return selectedTransactions
  }

  renderStorageTransactions = () => {
    if (!this.state.selectedstoragetype) {
      return <></>
    }
    const _selectedTransactions = this.state.storages
      .filter((venuesaldos) => venuesaldos.id === this.state.selectedstoragetype.venue)
      .map((s) => s[this.state.selectedstoragetype.category])
      .flat(1)
      .reverse()
    // do some formatting for transactions
    // eslint-disable-next-line array-callback-return
    const selectedTransactions = _selectedTransactions.map((t, i) => {
      if (t.purchasetype === 'reservation') {
        if (t.type === 'refund') {
          return (
            <Row
              key={'rtrans-' + i}
              style={{ marginLeft: 10, marginRight: 10, paddingTop: 3, paddingBottom: 3 }}
              className='border-bottom'
            >
              <Col xs={'2'} sm={'2'} md={'2'} lg={'2'}>
                {t.description.startsWith('Peruttu') ? 'Peruutus' : 'Tallennus'}
              </Col>
              <Col xs={'5'} sm={'5'} md={'5'} lg={'5'}>
                {t.description}
              </Col>
              <Col xs={'1'} sm={'1'} md={'1'} lg={'1'}>
                {this.state.selectedstoragetype.category === 'minutes' ? t.amount + ' min' : t.amount / 100 + ' €'}
              </Col>
              <Col xs={'1'} sm={'1'} md={'1'} lg={'1'}>
                {t.category}
              </Col>
              <Col xs={'1'} sm={'1'} md={'1'} lg={'1'}>
                {t.timestamp}
              </Col>
              <Col xs={'1'} sm={'1'} md={'1'} lg={'1'}>
                {t.validuntil}
              </Col>
            </Row>
          )
        } else if (t.type === 'purchase') {
          return (
            <Row
              key={'rtrans-' + i}
              style={{ marginLeft: 10, marginRight: 10, paddingTop: 3, paddingBottom: 3 }}
              className='border-bottom'
            >
              <Col xs={'2'} sm={'2'} md={'2'} lg={'2'}>
                Varaus
              </Col>
              <Col xs={'5'} sm={'5'} md={'5'} lg={'5'}>
                {t.description}
              </Col>
              <Col xs={'2'} sm={'2'} md={'2'} lg={'2'}>
                {this.state.selectedstoragetype.category === 'minutes' ? t.amount + ' min' : t.amount / 100 + ' €'}
              </Col>
              <Col xs={'3'} sm={'3'} md={'3'} lg={'3'}>
                {t.timestamp}
              </Col>
            </Row>
          )
        }
      } else {
        let title = ''
        if (t.type === 'compensation') {
          title = 'Hyvitys'
        } else if (t.type === 'transfer') {
          title = 'Siirto'
        } else if (t.type === 'deposit') {
          title = 'Talletus'
        } else {
          return <></>
        }
        return (
          <Row
            key={'rtrans-' + i}
            style={{ marginLeft: 10, marginRight: 10, minHeight: 40, paddingTop: 3, paddingBottom: 3 }}
            className='border-bottom'
          >
            <Col xs={'2'} sm={'2'} md={'2'} lg={'2'}>
              {title}
            </Col>
            <Col xs={'5'} sm={'5'} md={'5'} lg={'5'}>
              {t.description}
            </Col>
            <Col xs={'2'} sm={'2'} md={'2'} lg={'2'}>
              {t.amount / 100} €
            </Col>
            <Col xs={'3'} sm={'3'} md={'3'} lg={'3'}>
              {t.timestamp}
            </Col>
          </Row>
        )
      }
    })
    return selectedTransactions
  }

  toggleAddSaldo = () => {
    this.setState({ showAddSaldoRow: !this.state.showAddSaldoRow })
  }

  toggleAddStorage = () => {
    this.setState({ showAddStorageRow: !this.state.showAddStorageRow })
  }

  toggleAddMembership = () => {
    this.setState({ showAddMembershipRow: !this.state.showAddMembershipRow })
  }

  handleSaldoSaved = () => {
    this.getSaldo()
    this.toggleAddSaldo()
  }

  handleStorageSaved = () => {
    this.getStorage()
    this.toggleAddStorage()
  }

  handleMembershipSaved = () => {
    this.getMemberships()
    this.toggleAddMembership()
  }

  handleBenefitcardSaved = () => {
    this.getBenefitCards()
  }

  handleMembershipTerminated = () => {
    this.getMemberships()
  }

  handleOrganisationDataChange = (field, value) => {
    console.log('handleOrganisationDataChange', field, value)
    const organisation = { ...this.state.organisation }
    organisation[field] = value
    this.setState({ organisation: organisation, organisationDataSaved: false })
  }

  onSaveSaldoPayment = async () => {
    this.setState({ savingsaldo: true })
    const amount = parseInt((parseFloat(this.state.saldoamount.replace(',', '.')) * 100).toFixed(0))
    const description = this.state.saldodescription
    const type = this.state.saldotype
    const wallet = this.state.saldowallet
    const venue = this.state.saldovenue
    const userid = this.state.organisation.id
    /*const result = */ await this.props.firebase.addSaldoTransaction(userid, type, amount, description, wallet, venue)
    this.setState(
      {
        saldodescription: null,
        saldotype: null,
        saldowallet: null,
        saldovenue: null,
        saldoamount: 0,
        savingsaldo: false,
      },
      this.handleSaldoSaved
    )
  }

  onSaveStoragePayment = async () => {
    this.setState({ savingstorage: true })
    const amount = parseInt((parseFloat(this.state.storageamount.replace(',', '.')) * 100).toFixed(0))
    const description = this.state.storagedescription
    const type = this.state.storagetype
    const wallet = this.state.storagewallet
    const venue = this.state.storagevenue
    const userid = this.state.organisation.id
    /*const result = */ await this.props.firebase.addStorageTransaction(
      userid,
      type,
      amount,
      description,
      wallet,
      venue
    )
    this.setState(
      {
        storagedescription: null,
        storagetype: null,
        storagewallet: null,
        storagevenue: null,
        storageamount: 0,
        savingstorage: false,
      },
      this.handleStorageSaved
    )
  }

  onSaveMembership = async () => {
    this.setState({ savingmembership: true })
    const membershipid = this.state.membershipselection
    const note = this.state.membershipnote
    const start = this.state.membershipstart
    const end = this.state.membershipend
    const permanent = this.state.membershippermanent
    const organisationid = this.state.organisation.id
    await this.props.firebase.addNewOrganisationMembership(organisationid, membershipid, start, end, note, permanent)
    this.setState(
      {
        membershipnote: null,
        membershipend: moment.utc().endOf('year').format('YYYY-MM-DD'),
        membershipstart: moment.utc().format('YYYY-MM-DD'),
        membershippermanent: false,
        membershipselection: '',
        savingmembership: false,
      },
      this.handleMembershipSaved
    )
  }

  onTerminateMembership = async (id) => {
    this.setState({ savingmembership: true })
    const end = moment.utc().subtract(1, 'day').format('YYYY-MM-DD')
    const permanent = false
    const organidationid = this.state.organisation.id
    await this.props.firebase.terminateOrganisationMembership(organidationid, id, end, permanent)
    this.setState({ savingmembership: false }, this.handleMembershipTerminated)
  }

  openRemoveDialog = (id) => {
    this.toggleRemoveDialog()
    this.setState({ removablePersonId: id })
  }

  toggleOrganisationDataEdit = () => {
    if (this.state.organisationDataEdit) {
      this.setState({
        organisationDataSaved: true,
        organisationDataEdit: !this.state.organisationDataEdit,
      })
    } else {
      this.setState({ organisationDataEdit: !this.state.organisationDataEdit })
    }
  }

  saveOrganisationData = async () => {
    const org = { ...this.state.organisation }
    await this.props.firebase.updateOrganisation(org)
    this.toggleOrganisationDataEdit()
  }

  renderOrganisationData = () => {
    const {
      id,
      phone,
      name,
      businessId,
      email,
      address,
      city,
      zipcode,
      billingEmail,
      billingOperator,
      billingOvt,
      billingReference,
      www,
    } = this.state.organisation
    return (
      <>
        <Row id={id}>
          <Col xs={3}>Nimi</Col>
          {this.state.organisationDataEdit ? (
            <Col xs={6}>
              <TextField
                id='name'
                label='Nimi'
                type='text'
                size='small'
                value={name || ''}
                onChange={(e) => this.handleOrganisationDataChange('name', e.target.value)}
              />
            </Col>
          ) : (
            <Col xs={3}>{name}</Col>
          )}
        </Row>
        <Row>
          <Col xs={3}>Y-Tunnus</Col>
          {this.state.organisationDataEdit ? (
            <Col xs={6}>
              <TextField
                id='businessId'
                label='Y-Tunnus'
                type='text'
                size='small'
                value={businessId || ''}
                onChange={(e) => this.handleOrganisationDataChange('businessId', e.target.value)}
              />
            </Col>
          ) : (
              <Col xs={3}>{businessId} <a href={`https://www.finder.fi/search?what=${businessId}`} target="_blank" rel="noreferrer">Finder</a> <a href={`https://tietopalvelu.ytj.fi/yritys/${businessId}`} target="_blank" rel="noreferrer" >YTJ</a></Col>
          )}
        </Row>
        <Row>
          <Col xs={3}>Email</Col>
          {this.state.organisationDataEdit ? (
            <Col xs={6}>
              <TextField
                id='email'
                label='Email'
                type='text'
                size='small'
                value={email || ''}
                onChange={(e) => this.handleOrganisationDataChange('email', e.target.value)}
              />
            </Col>
          ) : (
            <Col xs={3}>{email}</Col>
          )}
        </Row>
        <Row>
          <Col xs={3}>Puhelin</Col>
          {this.state.organisationDataEdit ? (
            <Col xs={6}>
              <TextField
                id='phone'
                label='Puhelin'
                type='text'
                size='small'
                value={phone || ''}
                onChange={(e) => this.handleOrganisationDataChange('phone', e.target.value)}
              />
            </Col>
          ) : (
            <Col xs={3}>{phone}</Col>
          )}
        </Row>
        <Row>
          <Col xs={3}>Osoite</Col>
          {this.state.organisationDataEdit ? (
            <Col xs={6}>
              <TextField
                id='address'
                label='Osoite'
                type='text'
                size='small'
                value={address || ''}
                onChange={(e) => this.handleOrganisationDataChange('address', e.target.value)}
              />
            </Col>
          ) : (
            <Col xs={3}>{address}</Col>
          )}
        </Row>
        <Row>
          <Col xs={3}>Kaupunki</Col>
          {this.state.organisationDataEdit ? (
            <Col xs={6}>
              <TextField
                id='city'
                label='Kaupunki'
                type='text'
                size='small'
                value={city || ''}
                onChange={(e) => this.handleOrganisationDataChange('city', e.target.value)}
              />
            </Col>
          ) : (
            <Col xs={3}>{city}</Col>
          )}
        </Row>
        <Row>
          <Col xs={3}>Postinumero</Col>
          {this.state.organisationDataEdit ? (
            <Col xs={6}>
              <TextField
                id='zipcode'
                label='Postinumero'
                type='text'
                size='small'
                value={zipcode || ''}
                onChange={(e) => this.handleOrganisationDataChange('zipcode', e.target.value)}
              />
            </Col>
          ) : (
            <Col xs={3}>{zipcode}</Col>
          )}
        </Row>
        <Row>
          <Col xs={3}>Laskutus email</Col>
          {this.state.organisationDataEdit ? (
            <Col xs={6}>
              <TextField
                id='billingEmail'
                label='Laskutus email'
                type='text'
                size='small'
                value={billingEmail || ''}
                onChange={(e) => this.handleOrganisationDataChange('billingEmail', e.target.value)}
              />
            </Col>
          ) : (
            <Col xs={3}>{billingEmail}</Col>
          )}
        </Row>
        <Row>
          <Col xs={3}>Verkkolaskuosoite {billingOvt ? null : <a href={`https://verkkolaskuosoite.fi/client/index.html#/?searchText=${businessId}`} target="_blank" rel="noreferrer">Etsi</a>}</Col>
          {this.state.organisationDataEdit ? (
            <Col xs={6}>
              <TextField
                id='billingOvt'
                label='Verkkolaskuosoite'
                type='text'
                size='small'
                value={billingOvt || ''}
                onChange={(e) => this.handleOrganisationDataChange('billingOvt', e.target.value)}
              />
            </Col>
          ) : (
            <Col xs={3}>{billingOvt}</Col>
          )}
        </Row>
        <Row>
          <Col xs={3}>Verkkolaskuoperaattori</Col>
          {this.state.organisationDataEdit ? (
            <Col xs={6}>
              <BillingOperatorSelect
                value={billingOperator}
                onChange={(value) => this.handleOrganisationDataChange('billingOperator', value)}
              />
            </Col>
          ) : (
            <Col xs={3}>{billingOperator}</Col>
          )}
        </Row>
        <Row>
          <Col xs={3}>Asiakkaan viite</Col>
          {this.state.organisationDataEdit ? (
            <Col xs={6}>
              <TextField
                id='billingReference'
                label='Asiakkaan viite'
                type='text'
                size='small'
                value={billingReference || ''}
                onChange={(e) => this.handleOrganisationDataChange('billingReference', e.target.value)}
              />
            </Col>
          ) : (
            <Col xs={3}>{billingReference}</Col>
          )}
        </Row>
        <Row>
          <Col xs={3}>WWW</Col>
          {this.state.organisationDataEdit ? (
            <Col xs={6}>
              <TextField
                id='www'
                label='WWW'
                type='text'
                size='small'
                value={www || ''}
                onChange={(e) => this.handleOrganisationDataChange('www', e.target.value)}
              />
            </Col>
          ) : (
            <Col xs={3}>{www}</Col>
          )}
        </Row>
        {this.state.pin ? (
          <Row>
            <Col xs={3}>PIN</Col>
            <Col xs={3}>{this.state.pin}</Col>
          </Row>
        ) : null}
        {this.props.readOnly ? null : this.state.organisationDataEdit ? (
          <Row>
            <Col xs={3}></Col>
            <Col xs={3}></Col>
            <Col xs={3}>
              <Button
                color='primary'
                size='sm'
                onClick={this.saveOrganisationData}
                disabled={this.state.organisationDataSaved}
              >
                Tallenna
              </Button>
            </Col>
          </Row>
        ) : (
          <Row>
            <Col xs={3}>
              <Button size={'sm'} onClick={() => this.toggleOrganisationDataEdit()} color='success'>
                Muokkaa
              </Button>
            </Col>
          </Row>
        )}
      </>
    )
  }

  handleContactChange = (event, value) => {
    console.log('handleContactChange', value)
    const toupdate = { id: this.state.organisation.id }
    let contacts = []
    if (value) {
      contacts = value.map((x) => {
        return {
          id: x.id,
          firstname: x.firstname || '',
          lastname: x.lastname || '',
          email: x.email,
          phone: x.phone || '',
        }
      })
    }
    toupdate.contacts = contacts
    this.props.firebase.updateOrganisation(toupdate)
  }

  handleUserChange = (event, value) => {
    const toupdate = { id: this.state.organisation.id }
    let users = []
    if (value) {
      users = value.map((x) => {
        return {
          id: x.id,
          firstname: x.firstname || '',
          lastname: x.lastname || '',
          email: x.email,
          phone: x.phone || '',
        }
      })
    }
    toupdate.users = users
    console.log('handleUserChange', toupdate)
    this.props.firebase.updateOrganisation(toupdate)
  }

  renderOrganisationPersons = () => {
    const { contacts, users } = this.state.organisation
    if (this.props.readOnly) {
      // Plain names instead of the PersonSearch pickers, whose onChange writes straight to
      // the organisation. Email shown too: same-named people exist.
      const personLine = (p) => [[p.firstname, p.lastname].filter(Boolean).join(' '), p.email].filter(Boolean).join(', ')
      const list = (persons) =>
        persons && persons.length > 0 ? persons.map((p) => <div key={p.id || p.email}>{personLine(p)}</div>) : '—'
      return (
        <>
          <Row>
            <Col xs={3}>Yhteyshenkilö / pääkäyttäjä</Col>
            <Col xs={9}>{list(contacts)}</Col>
          </Row>
          <Row className='mt-2'>
            <Col xs={3}>Käyttäjät</Col>
            <Col xs={9}>{list(users)}</Col>
          </Row>
        </>
      )
    }
    return (
      <>
        <Row>
          <Col xs={3}>Yhteyshenkilö / pääkäyttäjä</Col>
          <Col xs={3}>
            <PersonSearch
              showEmail
              onChange={this.handleContactChange}
              values={contacts || null}
              label=' '
              placeholder=' '
              onlyone={true}
            />
          </Col>
          <Col xs={6}>
            <Infobox index={'1'} />
          </Col>
        </Row>
        <Row>
          <Col xs={3}>Käyttäjät</Col>
          <Col xs={9}>
            <PersonSearch
              variant='list'
              onChange={this.handleUserChange}
              showEmail
              values={users || null}
              label=' '
              placeholder='Lisää'
            />
          </Col>
        </Row>
      </>
    )
  }

  toggleNav = (tab) => {
    if (this.state.activeTab !== tab) this.setState({ activeTab: tab })
  }

  removeCustomershipFromOrganisation = async () => {
    // console.log('removeCustomershipFromOrganisation', this.state.organisation.id)
    await this.props.firebase.deleteOrganisation(this.state.organisation.id)
    this.toggleRemoveDialog()
  }

  renderAddSaldoRow = () => {
    return (
      <React.Fragment>
        <Row style={{ marginTop: 20 }}>
          {this.state.venues.length > 0 ? (
            <Col md='3'>
              <FormControl style={{ width: '100%' }}>
                <InputLabel id='venue'>Paikka</InputLabel>
                <Select
                  fullWidth
                  labelId='venue-label'
                  id='venue'
                  value={this.state.saldovenue || ''}
                  onChange={this.handleSaldoVenue}
                >
                  {this.state.venues.map((v, i) => {
                    return (
                      <MenuItem key={'venue' + i} value={v.toLowerCase()}>
                        {v}
                      </MenuItem>
                    )
                  })}
                </Select>
              </FormControl>
            </Col>
          ) : null}
          <Col md='3'>
            <FormControl style={{ width: '100%' }}>
              <InputLabel id='saldotype'>Saldo</InputLabel>
              <Select
                labelId='saldotype-label'
                id='saldotype'
                value={this.state.saldowallet || ''}
                onChange={this.handleSaldoWallet}
              >
                <MenuItem value={'cash'}>Käteinen</MenuItem>
                {/* <MenuItem value={'sportmoney'}>Liikuntaraha</MenuItem> */}
              </Select>
            </FormControl>
          </Col>
          <Col md='3'>
            <FormControl style={{ width: '100%' }}>
              <InputLabel id='paymenttype'>Tapahtuma</InputLabel>
              <Select
                fullWidth
                labelId='paymenttype-label'
                id='paymenttype'
                value={this.state.saldotype || ''}
                onChange={this.handleSaldoType}
              >
                <MenuItem key={'none'}></MenuItem>
                {paymenttypes.map((pt) => {
                  return (
                    <MenuItem key={pt.value} value={pt.value}>
                      {pt.label}
                    </MenuItem>
                  )
                })}
              </Select>
            </FormControl>
          </Col>
          <Col md='2'>
            <TextField
              id='paymentamount'
              label='Summa'
              type='text'
              value={this.state.saldoamount || ''}
              InputProps={{
                endAdornment: <InputAdornment position='end'>€</InputAdornment>,
              }}
              onChange={this.handleSaldoAmount}
            />
          </Col>
        </Row>
        <Row style={{ marginBottom: 20 }}>
          <Col md='8'>
            <TextField
              fullWidth
              id='saldodescription'
              label='Kuvaus'
              type='text'
              value={this.state.saldodescription || ''}
              onChange={this.handleSaldoDescription}
            />
          </Col>
          <Col md='4'>
            <Button
              outline
              size='sm'
              color='success'
              disabled={!(this.state.saldowallet && this.state.saldoamount && this.state.saldotype)}
              onClick={this.onSaveSaldoPayment}
            >
              {this.state.savingsaldo ? <Spinner size='sm' /> : 'Lisää'}
            </Button>
            <Button outline color='primary' size='sm' onClick={this.toggleAddSaldo}>
              Peruuta
            </Button>
          </Col>
        </Row>
      </React.Fragment>
    )
  }

  renderAddSaldoButton = () => {
    return (
      <Row style={{ marginTop: 5, marginBottom: 10 }}>
        <Col>
          <AddCircleIcon fontSize='small' onClick={this.toggleAddSaldo} /> Lisää saldoa
        </Col>
      </Row>
    )
  }

  renderAddStorageRow = () => {
    return (
      <React.Fragment>
        <Row style={{ marginTop: 20 }}>
          {this.state.venues.length > 0 ? (
            <Col md='3'>
              <FormControl style={{ width: '100%' }}>
                <InputLabel id='venue'>Paikka</InputLabel>
                <Select
                  fullWidth
                  labelId='venue-label'
                  id='venue'
                  value={this.state.storagevenue || ''}
                  onChange={this.handleStorageVenue}
                >
                  {this.state.venues.map((v, i) => {
                    return (
                      <MenuItem key={'venue' + i} value={v.toLowerCase()}>
                        {v}
                      </MenuItem>
                    )
                  })}
                </Select>
              </FormControl>
            </Col>
          ) : null}
          <Col md='3'>
            <FormControl style={{ width: '100%' }}>
              <InputLabel id='saldotype'>Pankki/Varasto</InputLabel>
              <Select
                labelId='saldotype-label'
                id='saldotype'
                value={this.state.storagewallet || ''}
                onChange={this.handleStorageWallet}
              >
                <MenuItem value={'cash'}>Käteinen</MenuItem>
                <MenuItem value={'minutes'}>Aika</MenuItem>
              </Select>
            </FormControl>
          </Col>
          <Col md='3'>
            <FormControl style={{ width: '100%' }}>
              <InputLabel id='paymenttype'>Tapahtuma</InputLabel>
              <Select
                fullWidth
                labelId='paymenttype-label'
                id='paymenttype'
                value={this.state.storagetype || ''}
                onChange={this.handleStorageType}
              >
                <MenuItem key={'none'}></MenuItem>
                {paymenttypes.map((pt) => {
                  return (
                    <MenuItem key={pt.value} value={pt.value}>
                      {pt.label}
                    </MenuItem>
                  )
                })}
              </Select>
            </FormControl>
          </Col>
          <Col md='2'>
            <TextField
              id='paymentamount'
              label='Määrä'
              type='text'
              value={this.state.storageamount || ''}
              InputProps={{
                endAdornment: <InputAdornment position='end'></InputAdornment>,
              }}
              onChange={this.handleStorageAmount}
            />
          </Col>
        </Row>
        <Row style={{ marginBottom: 20 }}>
          <Col md='8'>
            <TextField
              fullWidth
              id='saldodescription'
              label='Kuvaus'
              type='text'
              value={this.state.storagedescription || ''}
              onChange={this.handleStorageDescription}
            />
          </Col>
          <Col md='4'>
            <Button
              outline
              size='sm'
              color='success'
              disabled={!(this.state.storagewallet && this.state.storageamount && this.state.storagetype)}
              onClick={this.onSaveStoragePayment}
            >
              {this.state.savingstorage ? <Spinner size='sm' /> : 'Tallenna'}
            </Button>
            <Button outline color='primary' size='sm' onClick={this.toggleAddStorage}>
              Peruuta
            </Button>
          </Col>
        </Row>
      </React.Fragment>
    )
  }

  renderAddStorageButton = () => {
    return (
      <Row style={{ marginTop: 5, marginBottom: 10 }}>
        <Col>
          <AddCircleIcon fontSize='small' onClick={this.toggleAddStorage} /> Lisää pankkiin/varastoon tapahtuma
        </Col>
      </Row>
    )
  }

  handleTabChange = (event, newValue) => {
    this.setState({ tabValue: newValue })
  }

  renderAddMembershipRow = () => {
    if (this.state.showAddMembershipRow) {
      return (
        <>
          <Row style={{ marginTop: 10 }}>
            {this.state.membershipoptions.length > 0 ? (
              <Col md='4'>
                <FormControl style={{ width: '100%' }}>
                  <InputLabel id='membership'>Jäsenyys</InputLabel>
                  <Select
                    fullWidth
                    labelId='membership-label'
                    id='membership'
                    value={this.state.membershipselection || ''}
                    onChange={this.handleMembershipSelection}
                  >
                    {this.state.membershipoptions.map((v, i) => {
                      return (
                        <MenuItem key={'membrs' + i} value={v.id}>
                          {v.name}
                        </MenuItem>
                      )
                    })}
                  </Select>
                </FormControl>
              </Col>
            ) : null}
            <Col md='3'>
              <TextField
                id='membershipstart'
                label='Alkupäivä'
                type='date'
                variant='standard'
                value={this.state.membershipstart || moment.utc().format('YYYY-MM-DD')}
                onChange={this.handleMembershipStart}
              />
            </Col>
            <Col md='3'>
              <TextField
                id='membershipend'
                label='Loppupäivä'
                type='date'
                variant='standard'
                value={this.state.membershipend || moment.utc().endOf('year').format('YYYY-MM-DD')}
                onChange={this.handleMembershipEnd}
                disabled={this.state.membershippermanent}
              />
            </Col>
            <Col md='2'>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={this.state.membershippermanent}
                    onChange={this.handleMembershipPermanent}
                    name='membershippermanent'
                    color='primary'
                  />
                }
                label='Pysyvä'
              />
            </Col>
          </Row>
          <Row style={{ marginBottom: 20 }}>
            <Col md='8'>
              <TextField
                fullWidth
                id='membershipnote'
                label='Muistiinpano'
                type='text'
                value={this.state.membershipnote || ''}
                onChange={this.handleMembershipNote}
              />
            </Col>
            <Col md='4'>
              <Button
                outline
                size='sm'
                color='success'
                disabled={!(this.state.membershipselection && this.state.membershipstart && this.state.membershipend)}
                onClick={this.onSaveMembership}
              >
                {this.state.savingmembership ? <Spinner size='sm' /> : 'Lisää'}
              </Button>
              <Button outline color='primary' size='sm' onClick={this.toggleAddMembership}>
                Peruuta
              </Button>
            </Col>
          </Row>
        </>
      )
    } else {
      return (
        <Row style={{ marginTop: 5, marginBottom: 10 }}>
          <Col md='1'>
            <AddCircleIcon fontSize='small' onClick={this.toggleAddMembership} />
          </Col>
          <Col>Lisää jäsenyys</Col>
        </Row>
      )
    }
  }

  renderAclsTab = () => {
    if (this.state.acls) {
      // console.log('this.state.acls', this.state.acls)
      return (
        <React.Fragment>
          {ACL_FIELDS.map((k, i) => {
            if (k === 'allowpostpayment') {
              return (
                <Row style={{ marginTop: 10 }} key={'acl' + i}>
                  <Col md='12'>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={this.state.acls[k]}
                          onChange={(e) => this.setAcl({ allowpostpayment: e.target.checked })}
                          color='primary'
                        />
                      }
                      label='Maksupakotuksen ohitus'
                    />
                  </Col>
                </Row>
              )
            } else if (k === 'blocked') {
              return (
                <Row style={{ marginTop: 10 }} key={'acl' + i}>
                  <Col md='12'>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={this.state.acls[k]}
                          onChange={(e) => this.setAcl({ blocked: e.target.checked })}
                          color='primary'
                        />
                      }
                      label='Varauskielto'
                    />
                  </Col>
                </Row>
              )
            } else if (k === 'blockedMessage') {
              return (
                <Row style={{ marginTop: 10 }} key={'acl' + i}>
                  <Col md='12'>
                    <TextField
                      fullWidth
                      id='blockedMessage'
                      label='Varauskiellon syy (näkyy käyttäjälle)'
                      type='text'
                      value={this.state.acls[k] || ''}
                      onChange={(e) => this.setState({ acls: { blockedMessage: e.target.value } })}
                    />
                    <Button
                      outline
                      color='primary'
                      size='sm'
                      onClick={() => this.setAcl({ blockedMessage: this.state.acls[k] })}
                    >
                      Tallenna viesti
                    </Button>
                  </Col>
                </Row>
              )
            } else if (k === 'quotaoverride') {
              return (
                <Row style={{ marginTop: 10 }} key={'acl' + i}>
                  <Col md='12'>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={this.state.acls[k] || false}
                          onChange={(e) => this.setAcl({ quotaoverride: e.target.checked })}
                          color='primary'
                        />
                      }
                      label='Saa varata enemmän kuin mahdollinen irtovuorojen varausrajoitus.'
                    />
                  </Col>
                </Row>
              )
            }
            return null
          }).filter((v) => v)}
        </React.Fragment>
      )
    } else {
    }
  }

  renderMemberShipTab = () => {
    return (
      <React.Fragment>
        {this.renderOrganisationMemberships()}
        {this.props.readOnly ? null : this.renderAddMembershipRow()}
      </React.Fragment>
    )
  }

  handleMessageCollapse = (index) => {
    let open = this.state.messageopen
    open[index] = !open[index]
    this.setState({ messageopen: open })
  }

  renderMessages = () => {
    return this.state.messages.map((m, i) => {
      return (
        <React.Fragment key={'msg' + i}>
          <ListItem onClick={() => this.handleMessageCollapse(i)}>
            {this.state.messageopen && this.state.messageopen[i] ? <ExpandLess /> : <ExpandMore />}
            <ListItemText
              primary={m.subject}
              secondary={moment.unix(m.timestamp.seconds).format('DD.MM.YYYY HH:mm') + ' - ' + m.recipient}
            />
            {m.state === 'failed' ? (
              <ListItemSecondaryAction>
                <WarningIcon color='error' />
              </ListItemSecondaryAction>
            ) : null}
          </ListItem>
          <Collapse in={this.state.messageopen[i]} timeout='auto' unmountOnExit>
            <Row style={{ marginTop: 15, marginBottom: 30, marginLeft: 30 }}>
              <Col md='12'>
                <Typography variant='body1' color='textSecondary' component='pre'>
                  {m.body}
                </Typography>
              </Col>
            </Row>
          </Collapse>
          <Divider />
        </React.Fragment>
      )
    })
  }

  openMessageModal = (type, id) => {
    let _m = this.state.messaging
    _m.isOpen = !_m.isOpen
    _m.type = type
    if (type === 'passwordreset') {
      this.generatePasswordReset(id)
    }
    // const person = this.state.searchpersons.find((r) => r.id === id)
    this.setState({ messaging: _m })
  }

  generatePasswordReset = async (email) => {
    // console.log(email, ' to reset')
    let response = await this.props.firebase.getPasswordResetLink(email)
    // console.log(response)
    if (response.data.error) {
      this.setState({ passwordResetLink: response.data.error })
    } else {
      this.setState({ passwordResetLink: response.data.link })
    }
  }

  setNewEmail = (event) => {
    const newemail = event.target.value
    this.setState({ newemail })
  }

  setMessagebody = (event) => {
    let _m = this.state.messaging
    _m.body = event.target.value
    this.setState({ messaging: _m })
  }

  setMessageSubject = (event) => {
    let _m = this.state.messaging
    _m.subject = event.target.value
    if (_m.type === 'notification') {
      _m.toolong = event.target.value.length > 80
    }
    this.setState({ messaging: _m })
  }

  sendMessage = () => {
    this.setState({ sending: true })
    this.props.firebase
      .sendMessage(
        this.state.messaging.body,
        this.state.messaging.subject,
        this.state.organisation.email,
        this.state.organisation.id,
        ['usersearch']
      )
      .then((response) => {
        // console.log(response)
        this.closeMessageModal()
      })
  }

  sendConfirmation = () => {
    this.setState({ sending: true })
    this.props.firebase.sendConfirmation(this.state.newemail, this.state.organisation.id, 'fi').then((response) => {
      // console.log(response)
      this.closeMessageModal()
    })
  }

  closeMessageModal = () => {
    let _m = this.state.messaging
    _m.isOpen = false
    this.setState({ messaging: _m, passwordResetLink: 'Luodaan linkkiä ...', sending: false })
  }

  copyClicked = () => {
    this.setState({ copied: true })
    setTimeout(() => {
      this.setState({ copied: false })
    }, '6000')
  }

  createMessageModal = () => {
    let user = this.state.organisation
    let phone = user && user.phone ? user.phone : ''
    if (this.state.messaging.type === 'call') {
      return (
        <Modal isOpen={this.state.messaging.isOpen} toggle={this.closeMessageModal} className={'className'}>
          <ModalHeader toggle={this.closeMessageModal}>Soita</ModalHeader>
          <ModalBody>
            <a href={'tel://' + phone}>{phone}</a>
          </ModalBody>
          <ModalFooter>
            <Button color='secondary' onClick={this.closeMessageModal}>
              Sulje
            </Button>
          </ModalFooter>
        </Modal>
      )
    } else if (this.state.messaging.type === 'notification') {
      return (
        <Modal isOpen={this.state.messaging.isOpen} toggle={this.closeMessageModal} className={'className'}>
          <ModalHeader toggle={this.closeMessageModal}>Lähetä notifikaatio appsiin</ModalHeader>
          <ModalBody>
            <Form>
              <FormGroup>
                <Label for='notificationmessagebody'>Notifikaatio osa (80 merkkiä)</Label>
                <Input
                  invalid={this.state.messaging.toolong}
                  type='textarea'
                  name='notificationmessagebody'
                  id='notificationmessagebody'
                  onChange={this.setMessageSubject}
                />
              </FormGroup>
              <FormGroup>
                <Label for='notificationmessagebody'>Viesti (näkyy käyttäjälle appsissa)</Label>
                <Input
                  type='textarea'
                  name='notificationmessagebody'
                  id='notificationmessagebody'
                  onChange={this.setMessagebody}
                />
              </FormGroup>
            </Form>
          </ModalBody>
          <ModalFooter>
            <Button color='primary' onClick={this.sendMessage}>
              {this.state.sending ? <Spinner size='sm' /> : 'Lähetä'}
            </Button>{' '}
            <Button color='secondary' onClick={this.closeMessageModal}>
              Cancel
            </Button>
          </ModalFooter>
        </Modal>
      )
    } else if (this.state.messaging.type === 'email') {
      return (
        <Modal isOpen={this.state.messaging.isOpen} toggle={this.closeMessageModal} className={'className'}>
          <ModalHeader toggle={this.closeMessageModal}>Lähetä sähköposti</ModalHeader>
          <ModalBody>
            <Form>
              <FormGroup>
                <Label for='emailsubject'>Otsikko</Label>
                <Input type='text' name='emailsubject' id='emailsubject' onChange={this.setMessageSubject} />
              </FormGroup>
              <FormGroup>
                <Label for='emailbody'>Viesti</Label>
                <Input type='textarea' name='emailbody' id='emailbody' onChange={this.setMessagebody} />
              </FormGroup>
            </Form>
          </ModalBody>
          <ModalFooter>
            <Button color='primary' onClick={this.sendMessage}>
              {this.state.sending ? <Spinner size='sm' /> : 'Lähetä'}
            </Button>{' '}
            <Button color='secondary' onClick={this.closeMessageModal}>
              Cancel
            </Button>
          </ModalFooter>
        </Modal>
      )
    } else if (this.state.messaging.type === 'passwordreset') {
      let r = this.state.passwordResetLink.startsWith('http')
      return (
        <Modal isOpen={this.state.messaging.isOpen} toggle={this.closeMessageModal} className={'className'}>
          <ModalHeader toggle={this.closeMessageModal}>Salasanan nollaus</ModalHeader>
          <ModalBody>
            {r ? (
              <React.Fragment>
                <code>{this.state.passwordResetLink}</code>
                <br />
                <br />
                <CopyToClipboard
                  text={this.state.passwordResetLink ? this.state.passwordResetLink : ''}
                  onCopy={this.copyClicked}
                >
                  <Button disabled={this.state.copied}>{this.state.copied ? 'Kopioitu' : 'Kopioi'}</Button>
                </CopyToClipboard>
              </React.Fragment>
            ) : (
              <React.Fragment>
                <Spinner size={'sm'} /> Luodaan linkkiä ...
              </React.Fragment>
            )}
          </ModalBody>
          <ModalFooter>
            <Button color='secondary' onClick={this.closeMessageModal}>
              Sulje
            </Button>
          </ModalFooter>
        </Modal>
      )
    } else if (this.state.messaging.type === 'emailchange') {
      return (
        <Modal isOpen={this.state.messaging.isOpen} toggle={this.closeMessageModal} className={'className'}>
          <ModalHeader toggle={this.closeMessageModal}>Sähköpostin vaihto</ModalHeader>
          <ModalBody>
            <Form>
              <FormGroup>
                <Label for='newemail'>Uusi email</Label>
                <Input type='text' name='newemail' id='newemail' onChange={this.setNewEmail} />
              </FormGroup>
            </Form>
          </ModalBody>
          <ModalBody>
            Käyttäjälle lähtee uuteen sähköpostiin viesti jossa on vahvistuskoodi jolla hän voi vahvistaa uuden
            sähköpostiosoitteen.
            <br />
            <br />
            Vahvistaminen
            <br />
            <br />
            * Käyttäjä kirjautuu vanhalla osoitteella varausjärjestelmään
            <br />
            * Omat tiedot kohdassa on nappi vahvistuskoodi josta painamalla pääsee syöttämään vahvistuksen
            <br />
            * Käyttäjän sähköposti ei muutu mikäli vahvistuskoodia ei syötetä
            <br />
          </ModalBody>
          <ModalFooter>
            <Button color='primary' onClick={this.sendConfirmation}>
              {this.state.sending ? <Spinner size='sm' /> : 'Lähetä vahvistusviesti'}
            </Button>{' '}
            <Button color='secondary' onClick={this.closeMessageModal}>
              Peru
            </Button>
          </ModalFooter>
        </Modal>
      )
    }
  }

  getColDefinitionsForReservations = () => {
    const cols = [
      {
        headerName: 'Päivä',
        field: 'starttime',
        disableClickEventBubbling: true,
        valueFormatter: (value) => {
          return new Date(value).toLocaleDateString()
        },
      },
      {
        headerName: 'Alku',
        field: 'start',
        disableClickEventBubbling: true,
      },
      {
        headerName: 'Loppu',
        field: 'end',
        disableClickEventBubbling: true,
      },
      { headerName: 'Kenttä', field: 'court' },
      {
        headerName: 'Vakio/Irto',
        field: 'reservationtype',
      },
      {
        headerName: 'Hinta',
        field: 'cost',
        valueFormatter: (value) => {
          return value + ' €'
        },
      },
      {
        headerName: 'Maksettu',
        field: 'paid',
      },
      {
        headerName: 'Laskutettu',
        field: 'invoiced',
        maxWidth: 70,
      },
      {
        headerName: 'Tila',
        field: 'stateName',
        maxWidth: 70,
      },
      {
        headerName: 'Muokkaa',
        field: 'edit',
        disableClickEventBubbling: true,
        renderCell: (params) => {
          return (
            <EditButton
              onClick={() => {
                this.handleSelectEvent(params.row.id, params.row.occurency)
              }}
            />
          )
        },
      },
    ]
    return cols.map((x) => {
      return { ...x, flex: 1 / cols.length }
    })
  }

  render() {
    if (!this.state.organisation) {
      return <></>
    }

    const { name } = this.state.organisation
    return (
      <div style={{ padding: 20, backgroundColor: 'white' }}>
        <Row>
          <Col>
            <Typography variant='h4'>{name}</Typography>
          </Col>
          {/* readOnly (cashiers): every control that changes the organisation is hidden -
              this button, the data Muokkaa, the person pickers and membership end/add.
              Reservations stay editable: that edits the reservation, not the organisation. */}
          {this.props.readOnly ? null : (
            <Col className='text-right'>
              <Button size={'sm'} onClick={() => this.toggleRemoveDialog()} color='danger'>
                Poista asiakkuus (piilota)
              </Button>
            </Col>
          )}
        </Row>
        {/* <Row>
          <Col>
            <MuiButton
              variant='outlined'
              size='small'
              onClick={(el) => {
                this.openMessageModal('call', id)
              }}
            >
              <PhoneIcon fontSize='small' /> Soita
            </MuiButton>{' '}
            <MuiButton
              variant='outlined'
              size='small'
              onClick={(el) => {
                this.openMessageModal('email', email)
              }}
            >
              <MailOutlineIcon fontSize='small' /> Lähetä email
            </MuiButton>{' '}
            <MuiButton
              variant='outlined'
              size='small'
              onClick={(el) => {
                this.openMessageModal('passwordreset', email)
              }}
            >
              <VpnKeyIcon fontSize='small' /> Salasanan vaihto
            </MuiButton>{' '}
            <MuiButton
              variant='outlined'
              size='small'
              onClick={(el) => {
                this.openMessageModal('emailchange', id)
              }}
            >
              <AlternateEmailIcon fontSize='small' /> Vaihda email
            </MuiButton>
          </Col>
        </Row> */}
        <Row className='mt-2 border-bottom mb-2'>
          <Col>
            <Tabs
              value={this.state.tabValue}
              indicatorColor='primary'
              // textColor="primary"
              onChange={this.handleTabChange}
              // aria-label="disabled tabs example"
              variant='scrollable'
            >
              <Tab label='Yhteys- ja laskutustiedot' />
              <Tab label='Henkilöt' />
              {/* <Tab label='Saldot' /> */}
              <Tab label='Varaukset' />
              <Tab label='Jäsenyydet' />
            </Tabs>
          </Col>
        </Row>
        <Row>
          <Col>
            <TabPanel value={this.state.tabValue} index={0}>
              {this.renderOrganisationData()}
            </TabPanel>
            <TabPanel value={this.state.tabValue} index={1}>
              {this.renderOrganisationPersons()}
            </TabPanel>
            {/* <TabPanel value={this.state.tabValue} index={2}>
              {!this.state.saldoloading && !this.state.storageloading ? (
                <React.Fragment>
                  <Row>
                    <Col>
                      <Typography variant='h6' gutterBottom>
                        Saldo
                      </Typography>{' '}
                      {this.state.showAddSaldoRow ? this.renderAddSaldoRow() : this.renderAddSaldoButton()}
                    </Col>
                  </Row>
                  <Row>
                    <Col>{this.renderSaldoData()}</Col>
                  </Row>
                  <Row className='mt-3'>
                    <Col>{this.renderSaldoTransactions()}</Col>
                  </Row>
                  <Row className='border-top'>
                    <Col>
                      <Typography variant='h6' gutterBottom>
                        Pankki / Varasto
                      </Typography>{' '}
                      {this.state.showAddStorageRow ? this.renderAddStorageRow() : this.renderAddStorageButton()}
                    </Col>
                  </Row>
                  <Row>
                    <Col>{this.renderStorageData()}</Col>
                  </Row>
                  <Row>
                    <Col>{this.renderStorageTransactions()}</Col>
                  </Row>
                </React.Fragment>
              ) : (
                <Row className='text-center'>
                  <Col>
                    <Spinner />
                  </Col>
                </Row>
              )}
            </TabPanel>
              */}
            <TabPanel value={this.state.tabValue} index={2}>
              <div style={{ display: 'flex', minHeight: 'calc(100vh - 400px)', backgroundColor: '#FFFFFF' }}>
                <div style={{ flexGrow: 1 }}>
                  <DataGrid
                    rows={this.state.formattedReservations}
                    columns={this.getColDefinitionsForReservations()}
                    density='compact'
                    pageSize={20}
                    disableSelectionOnClick={true}
                    rowsPerPageOptions={[20, 50, 100]}
                    pagination
                  />
                </div>
              </div>
            </TabPanel>
            <TabPanel value={this.state.tabValue} index={3}>
              {this.state.membershipsloading ? (
                <Row className='text-center'>
                  <Col>
                    <Spinner />
                  </Col>
                </Row>
              ) : (
                this.renderMemberShipTab()
              )}
            </TabPanel>
          </Col>
        </Row>
        <Modal size='sm' isOpen={this.state.loadingModalOpen} toggle={this.toggleLoadingModal} backdrop={'static'}>
          <ModalBody>
            <Spinner />
          </ModalBody>
        </Modal>
        <Dialog
          fullWidth={true}
          maxWidth={'sm'}
          open={this.state.removeOrganisationConfirmation}
          onClose={this.toggleRemoveDialog}
          aria-labelledby='max-width-dialog-title'
          style={{ zIndex: '1000' }}
        >
          <DialogTitle id='max-width-dialog-title'>Vahvista poisto</DialogTitle>
          <DialogContent>
            Oletko aivan varma, että haluat poistaa asiakkuuden tältä organisaatiolta? Muista takistaa onko organisaatiolla
            maksamattomia varauksia ennen kuin poistat asiakkuuden. Poistamiseen menee hetken aikaa jonka jälkeen
            organisaatio ei löydy enää hausta.
          </DialogContent>
          <DialogActions>
            <Button onClick={() => this.removeCustomershipFromOrganisation()} color='danger'>
              Poista asiakkuus (piilota)
            </Button>
            <Button onClick={this.toggleRemoveDialog} color='primary'>
              Sulje
            </Button>
          </DialogActions>
        </Dialog>
        {this.createMessageModal()}
      </div>
    )
  }
  // }
}

export default withFirebase(OrganisationDetails)
